<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Aan9YU/images/9780316381055.jpg?1733151293592" alt="This image is the cover for the book Coming to You Live, Newsflesh"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Coming to You Live, Newsflesh
      </h1>
      <p class="bookDescription body article font2">
        <b>A Newflesh novella from the <i>New York Times </i>bestselling author that brought you <i>Feed</i>, Mira Grant.</b><br/><br/>Shaun and Georgia Mason got out. That's the story people tell, anyway. They told the truth and they lived happily ever after, somewhere in the wilds of Canada. But running away is complicated, and when circumstances force them to return to what they left behind, they'll have to face the consequences of their own actions . . . and the actions of others.<br/><br/><br/>More from Mira Grant:<br/> <br/><b>Newsflesh</b><br/><i>Feed</i><br/><i>Deadline</i><br/><i>Blackout</i><br/><i>Feedback</i><br/> <br/><i>Rise</i><br/> <br/><b>Newsflesh Short Fiction</b><br/><i>Countdown</i><br/><i>Everglades</i><br/><i>Sand Diego 2014</i><br/><i>How Green This Land, How Blue This Sea</i><br/><i>The Day the Dead Came to Show and Tell</i><br/><i>Please Do Not Taunt the Octopus</i><br/><i>All the Pretty Little Horses</i><br/><i>Coming to You Live</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mira Grant
      </h2>
      
      <p class="authorDescription body article"><B>Mira Grant</B> lives in California, sleeps with a machete under her bed, and highly suggests you do the same.  Mira Grant is the pseudonym of Seanan McGuire -- winner of the 2010 John W. Campbell Award for best new writer.  Find out more about the author at www.miragrant.com or follow her on twitter @seananmcguire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Orbit
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7ad9f3ce